import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import SearchBar from '../../../../Components/Utils/SearchBar';
import { BackButton, ClearFilterButton, CreateButton, DownloadButton, EditButton, ExportButton, FilterButton, ImportButton } from '../../../../Components/Utils/Buttons';
import { Card, List } from 'antd';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import axiosInstance from '../../../../Services/axiosCommon';
import { useSurvey } from './SurveyContext';

const SurveyReportLayout = ({
    getData=() => {},
    setSearchQuery=()=>{},
    EditAccess= false,
    ImportAccess= false,
    setOpen=()=>{},
    setOpenExport=()=>{},
    children,
    onCreateClick,
    searchValue="",
    searchFun=()=>{},
    isFilter=false,
    setFilterOpen=()=>{},
    newfilter=false,
    ClearFilter=()=>{},
    neededSearch=false,
    showproject=true,
    isCard=true,
    setViewMode=()=>{},
        viewMode="",
        ExportAccess=false
        
        

}
) => {
const location = useLocation();
  const data = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [percentOpen, setPercentOpen] = useState(false);

  let {pathname} = useLocation()
  const [module,setModule] = useState("")
  const navigate = useNavigate();
  const {surveyReportFormViewId,surveyReportViewId}=useParams();
         
      const {equipmentsView } = useSurvey();
    
    
    let searchList = [
        { value: "all", label: "All" },
        { value: "services", label: "Services" },
        { value: "products", label: "Products" },
      ];

        const [screenSize, setScreenSize] = useState({
          width: window.innerWidth,
        });
      
        useEffect(() => {
          const handleResize = () => {
            setScreenSize({
              width: window.innerWidth,
            });
          };
      
          window.addEventListener("resize", handleResize);
      
          return () => {
            window.removeEventListener("resize", handleResize);
          };
        }, []);
        useEffect(() => {
            if (pathname == `/Contract-management/survey-report/view/${surveyReportViewId}`) {
              setModule("Details");
            } else if (pathname == `/Contract-management/survey-report/form/${surveyReportViewId}`) {
              setModule("Forms");
            }
            else if (pathname == `/Contract-management/survey-report/equipments/${surveyReportViewId}`) {
              setModule("Equipment");
            }
          }, [pathname]);
        
          let LinkItem = [
            {
              label: "Details",
              link: `/Contract-management/survey-report/view/${surveyReportViewId}`,
              access: true,
            },
            {
              label: "Survey Form",
        
              link: `/Contract-management/survey-report/form/${surveyReportViewId}`,
              access: GetAccess('survey_form_view'),
            },
            {
              label: "Equipment",
              link: `/Contract-management/survey-report/equipments/${surveyReportViewId}`,
              // access: GetAccess(''),
      key: "survey_equipments",

      view: equipmentsView || false,

            },
          ];

  const handleCreateClick = () => {
    if (module === "Cont. Equipt.") {
        onCreateClick && onCreateClick(); 
    } else {
      navigate(`${pathname}/create`);
    }
  };

  // const downloadPDF = async () => {
  //   try {
  //       const response = await axiosInstance.get(`/surveyInspectionForm/generate-report/${surveyReportViewId}`, {
  //           responseType: 'blob' // Important to specify the response type as blob
  //       });
  
  //       // Create a Blob from the response
  //       const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
  
  //       // Create a link element
  //       const link = document.createElement('a');
  //       link.href = window.URL.createObjectURL(pdfBlob);
  //       link.download = `${data.refNumber}.pdf`; // The filename you want for the downloaded file
  
  //       // Append the link to the body (required for Firefox)
  //       document.body.appendChild(link);
  
  //       // Programmatically click the link to trigger the download
  //       link.click();
  
  //       // Clean up and remove the link
  //       link.parentNode.removeChild(link);
  
  //   } catch (error) {
  //       console.error('Error downloading the PDF:', error);
  //   }
  // };
  

  return(
    <div className=" w-full  h-full py-2 px-4 md:overflow-hidden">
            
            <div className="md:flex justify-between w-full ">
               <div className="md:flex justify-between w-full">
                      <Breadcrumb
                        items={[
                         
                          
                          {
                            name: "Survey",
                            link:"/Contract-management/survey-report"
                           
                          },
              
                          { name: module },
                        ]}
                      />
<div className=" flex justify-end items-center gap-3 ">

                                             <div className=" flex gap-2">
          {/* <Link
            to={`/Contract-management/survey-report`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link> */}

          
                         <BackButton
                          link={true}
                          hasLink={
                            module !== "Details"
                              ? `/Contract-management/survey-report`
                              : `/Contract-management/survey-report`
                          }
                          state={
                            module === "Details"
                              ? {
                                  currentPage: pageIndex,
                                  searchQuery: searchQuery !== "" ? searchQuery : "",
                                }
                              : null
                          }
                        />
          
          {/* <DownloadButton svg={false} handleClick={downloadPDF} label="Download as PDF" /> */}

          {EditAccess &&  <Link
            to={`/Contract-management/survey-report/edit/${surveyReportViewId}`}
            state={{
              data: data,
              from: `/Contract-management/survey-report/view/${surveyReportViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>}
        </div>
        </div>

                      </div>
           





            </div>
            <div className=" w-full  flex items-center gap-x-1 ">
            {
                LinkItem && LinkItem.map((item, i) => {
      const isActive = item?.link === pathname;

                    return(
                        <>
                         {
                            item.access && (

                              <Link
                                                                                          to={item?.link}
                                                                                          key={item?.link}
                                                                                          className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                                                                                            ${isActive 
                                                                                              ? "bg-baseColor-primary text-white" 
                                                                                              : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                                                                                            }`}
                                                                                        >
                                                                                          {item?.label || ""}
                                                                                        </Link>
                                                    // <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>
                                     )
                         }
                        </>
                    )
                })
            }
        </div>
           
           
           
            <div className=" w-full h-[calc(100vh-175px)] md:h-[calc(100vh-165px)]  ">
               {children} 
            </div>
            </div>
       
)
    }

export default SurveyReportLayout